import { render, staticRenderFns } from "./ReassignCallPanel.vue?vue&type=template&id=4b8188da&"
import script from "./ReassignCallPanel.vue?vue&type=script&lang=js&"
export * from "./ReassignCallPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports